import Vue from 'vue';
import { getBrowserInfo } from "lib/Utilities";
export default new Vue({
    el: '#footer',
    data() {
        return {
            supportUrl: '',
            suggestUrl: '',
            site: window.s.site,
            currentUrl: window.location.href,
            browser: '',
            user: window.s.user,
            fullName: '',
            email: '',
            userId: '',
            locale: window.l.locale
        };
    },
    created() {
        this.supportUrl = this.locale === 'fr' ?
            new URL('https://www.venngo.com/fr/contact-support') :
            new URL('https://www.venngo.com/contact-support?hsCtaTracking=2ccdb1c2-4c96-4993-ae82-d6c63faae428%7C4a660646-ab5a-4b28-80ce-9e43c4c37946');
        this.suggestUrl = this.locale === 'fr' ?
            new URL('https://survey.hsforms.com/1MZ5EHSPaQcaNIf1p-QeCfA4qs0p') :
            new URL('https://survey.hsforms.com/1kiQCBjgNTha8echMByJJnA4qs0p');
        const browserInfo = getBrowserInfo;
        this.browser = {
            'currentUrl': this.currentUrl,
            'browserName': browserInfo.name,
            'browserVersion': browserInfo.version,
            'operatingSystem': browserInfo.os,
        };
    },
    mounted() {
        this.constructSupportLink();
        this.constructSuggestLink();
    },
    methods: {
        constructSupportLink() {
            const url = new URL(this.supportUrl);
            if (this.user) {
                url.searchParams.set('firstname', this.user.first_name);
                url.searchParams.set('lastname', this.user.last_name);
                url.searchParams.set('email', this.user.email);
            }
            url.searchParams.set('support_company_name', this.site.name);
            url.searchParams.set('venngo_session_info', JSON.stringify(this.browser));
            this.supportUrl = url;
        },
        constructSuggestLink() {
            const url = this.locale === 'fr' ?
                new URL('https://survey.hsforms.com/1MZ5EHSPaQcaNIf1p-QeCfA4qs0p') :
                new URL('https://survey.hsforms.com/1kiQCBjgNTha8echMByJJnA4qs0p');
            this.user && url.searchParams.set('email', this.user.email);
            /*
            * The reason to concat the string below instead of using the set function is that
            * hubspot does not take "+" as a space for the suggest a perk from. It prints Apple+Inc.
            * It will only print Apple Inc. if we define it with %20 which will be the case with
            * the below code
            */
            this.suggestUrl = `${url}&venngo_suggested_program_name=${this.site.name}`;
        },
    }
});
